var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('FilterSelect',{attrs:{"data-testid":"date-filter","label":"Período","value":_vm.filterValue,"options":_vm.formattedOptions,"use-option-label":"","disabled":_vm.disabled},on:{"change":_vm.emitOnSelectFilter}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }